import styled from 'styled-components';
import { LinkRegion } from '@sparknz/tracking';

const CardLinkRegion = styled(LinkRegion)`
  height: 100%;
`;

export default CardLinkRegion;
